$(document).ready(function(){
//RQ! code for 'Currency and Language dropdowns' STARTS  
   $(".rq-hide-onload").hide();
   //$(".rq-full-main-slide-lang-curr").hide();
   setTimeout(function () {
     $(".rq-hide-onload").show();
     //$(".rq-full-main-slide-lang-curr").show();
   }, 500);   
   setTimeout(function () {
     $(".rq-hide-onload2").show();
   }, 800); 
   $(".rq-lang-and-currency-one .SelectButton").click(function(){
     var getval = $(this).attr('aria-expanded');
     if(getval == 'false'){
        $("#header-currency-popover").attr('aria-hidden', 'false');
        $(this).attr('aria-expanded', 'true');
     } else {
        $(this).attr('aria-expanded', 'false');
        $("#header-currency-popover").attr('aria-hidden', 'true')
     } 
  });
  	//RQ! code for 'Currency and Language dropdowns' ENDS

  // RQ! swatch condtions for "swatch-color_" START
  var gb = $("li").closest(".rq-ul-color-swatch").find(".rq-have-tag-swatch").html();
  if(gb) {
     $(".rq-have-tag-swatch").closest("li.HorizontalList__Item.rq-color-margin").find(".rq-no-have-tag-swatch").hide();
  }
	// RQ! swatch condtions for "swatch-color_" ENDS
  
  // RQ! Blog condition for title block STARTS
  $("div.html-section:has(.rq-padding-fix)").addClass( "rq-padding-fix-contnr" );
	// RQ! swatch condtions for "swatch-color_" ENDS
  
});

 
/*RQ! added code for 'First image of products for Boost's loop' STARTS*/
  $(document).ready(function($) {
        $(document).on('mouseover','.rq-get-hover', function(){  
            var rq_getimg = $(this).closest("li.HorizontalList__Item.rq-color-margin").find('.rq-get-changeimage').attr('src');
           
            $(this).closest(".js-product_section").find(".rq-first-img-hover").attr('src', rq_getimg);
            $(this).closest(".js-product_section").find(".rq-first-img-hover").attr('data-src', rq_getimg);
    		$(this).closest(".js-product_section").find(".rq-first-img-hover").attr('srcset', rq_getimg);
    		$(this).closest(".js-product_section").find(".rq-first-img-hover").attr('data-srcset', rq_getimg);
    		 
            //$(this).closest(".js-product_section").find(".secondary").attr('src', rq_getimg);
            //$(this).closest(".js-product_section").find(".secondary").attr('data-src', rq_getimg);
    		//$(this).closest(".js-product_section").find(".secondary").attr('srcset', rq_getimg);
    		//$(this).closest(".js-product_section").find(".secondary").attr('data-srcset', rq_getimg);
    		  
            
          //$(this).attr('src', src);
    	});
        $(document).on('mouseout','.rq-new-color-space', function(){
        //$(document).on('mouseout','.rq-get-hover', function(){
            var rq_getimg = $(this).find('.rq-orignal-img-frist-show').attr('src');
    		//var rq_getimg = $(this).closest(".rq-new-color-space").find('.rq-orignal-img-frist-show').attr('src');
             $(this).closest(".js-product_section").find(".rq-first-img-hover").attr('src', rq_getimg);
             $(this).closest(".js-product_section").find(".rq-first-img-hover").attr('data-src', rq_getimg);
    		 $(this).closest(".js-product_section").find(".rq-first-img-hover").attr('srcset', rq_getimg);
    		 $(this).closest(".js-product_section").find(".rq-first-img-hover").attr('data-srcset', rq_getimg);
    	});	
}); 
/*RQ! added code for 'First image of products for Boost's loop' ENDS*/

$(document).ready(function($) {
  setTimeout(function () { 
    //$('.message-header').show();
  }, 500);  
});

/*RQ! added code for 'Header overlay change' STARTS*/
$(window).scroll(function() {    
    var scroll = $(window).scrollTop();
    if (scroll >= 100) {
        $(".header-sticky-wrapper").addClass("rq-white-header");
    } else {
        $(".header-sticky-wrapper").removeClass("rq-white-header");
    }
});
/*RQ! added code for 'Header overlay change' ENDS*/

$('.product-bundle-select').on('click', function(){
  let bundleItemId = $(this).data('prodid');
  let bundleItemCxPrice = $(this).data('cxprice');
  let bundleItemComparePrice = $(this).data('compareprice');

  $('.product-bundle-size').removeClass('active');
  $(this).parent().addClass('active')
  
  $('.final-bundle-input').val(bundleItemId);

  $('.bundle-costco-price').html(bundleItemCxPrice);

  if(bundleItemComparePrice){
    $('.bundle-price-title').html('Promo');
    $('.bundle-compare-price-wrapper').removeClass('hidden');
    $('.bundle-compare-price').html(bundleItemComparePrice);
  }else{
    $('.bundle-price-title').html('Costco');
    $('.bundle-compare-price-wrapper').addClass('hidden');
    $('.bundle-compare-price').html('Select a variant to see price');
  }
});